import React from "react";
import { makeStyles, Link, Theme } from "@material-ui/core";
//import { FilterMenu, FilterMenuProps } from "./ResponseFilter/FilterMenu";
import {
  FilterActivity,
  FilterActivityProps,
} from "./ResponseFilter/FilterActivity";
import { FilterList } from "@material-ui/icons";
import { useSearch } from "@ofqual/portal-core/core/hooks";
import { QueryParams } from "@ofqual/portal-core/core/types";

const FILTER_BUTTON_WIDTH = 50;

const useStyles = makeStyles<
  Theme,
  { haveFilter: boolean; actionCount: number }
>((theme) => ({
  actionBar: {
    height: 50,
    backgroundColor: "#293445",
    bottom: 5,
    width: "100%",
    color: theme.palette.grey[100],
    "& $button": {
      "&:disabled": {
        color: "#ffffff50",
        "&:hover": {
          backgroundColor: "#293445",
        },
      },
      "&:hover": {
        backgroundColor: "#1c232f",
      },
    },
  },

  actionButton: ({ haveFilter, actionCount }) => ({
    width: `calc((100% - ${haveFilter ? FILTER_BUTTON_WIDTH : 0}px)/${Math.max(
      3,
      actionCount
    )})`,
    borderLeftWidth: 1,
    border: 0,
    borderRadius: 0,
    boxShadow: "none",
    borderLeftStyle: "solid",
    borderLeftColor: theme.palette.grey[500],
    // marginTop: 5,
    // marginBottom: 5,
    height: "calc(100% )",
    float: "right",
    textTransform: "uppercase",
    fontSize: "0.70rem",
    fontWeight: "bold",
    "&:hover": {
      textDecoration: "none",
    },
    padding: "5px",
    paddingRight: 5,
  }),
  filterButtonContainer: {
    float: "left",
    width: FILTER_BUTTON_WIDTH,

    "& button": {
      marginTop: -2,
    },
  },
}));

export type ScrollableAreaTabAction = {
  label: string;
  disabled?: boolean;
  action: (element: HTMLElement) => void;
  dataTest?: string;
};

export type ScrollableAreaTabFooterProps = {
  params?: QueryParams;
  actions: ScrollableAreaTabAction[];
  activeFilters?: number;
  children?: FilterActivityProps["children"];
  navigate?: (newParams: QueryParams) => void;
};

export const ScrollableAreaTabFooter: React.FC<ScrollableAreaTabFooterProps> = ({
  params,
  children,
  actions,
  activeFilters,
  navigate
}) => {
  if ((children && !navigate) || (navigate && !children)) {
    throw new Error(
      "When using a filter menu with `ScrollableAreaTabFooter` pass both the navigate prop and children, otherwise pass neither."
    );
  }

  const classes = useStyles({
    haveFilter: !!children,
    actionCount: actions.length,
  });

  const search = useSearch({
    navigate: navigate || (() => { }),
    searchParams: params || {},
  });

  return (
    <div className={classes.actionBar}>
      {children && (
        <span className={classes.filterButtonContainer}>
          <FilterActivity
            dataTest="scrollable-area-filter-menu"
            Icon={FilterList}
            search={search}
            showMenuAboveButton
            filterCount={activeFilters}
          >
            {children}
          </FilterActivity>
        </span>
      )}
      {actions.map((action) => (
        <React.Fragment key={action.label}>
          <Link
            className={classes.actionButton}
            data-test={action.dataTest}
            color="inherit"
            component="button"
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              action.action(event.target as HTMLElement);
            }}
            disabled={action.disabled}
          >
            {action.label}
          </Link>{" "}
        </React.Fragment>
      ))}
    </div>
  );
};
